export default __webpack_public_path__ + "static/15_32-506ebefb15c4a7f3851eba58ac87ede1.png";